import React, { useContext } from 'react'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'

import { SiteModeContext } from '../MainFrame'
import { GlobalContext, UserContext } from '../../../App'
import { Stack, Tooltip } from '@mui/material'
import { Lock } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const SideBarDivider = ({ text, sideBarCollapsed, requiredTier, navTo }) => {
  const SBStateContext = useContext(SiteModeContext)
  const { collapsed, mobileOpen } = SBStateContext.sidebarState
  const { tenantInfo, setUpgradeRequired } = useContext(GlobalContext)
  const { user } = useContext(UserContext)

  const navigate = useNavigate()

  const upgradeRequired = requiredTier
    ? Number(requiredTier) > Number(tenantInfo?.subscriptionTier)
    : false

  const shouldSeeUpgrade = user?.security?.isSiteAdmin

  if (upgradeRequired && !user?.security?.isSiteAdmin) return null

  if (collapsed) {
    return null
  } else if (!text) {
    return <Divider sx={{ backgroundColor: 'white' }} />
  } else
    return (
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        className="sidebar_divider"
        onClick={() => upgradeRequired && navTo && navigate(navTo)}
      >
        <Box
          sx={{
            color: '#9BA8B8',
            fontSize: '10px',
            textTransform: 'uppercase',
            fontWeight: 800,
            letterSpacing: 0,
            cursor: upgradeRequired ? 'not-allowed' : 'inherit',
          }}
        >
          {text}
        </Box>
        {shouldSeeUpgrade && upgradeRequired && (
          <Tooltip title="Upgrade Required">
            <Lock sx={{ fontSize: 18, color: '#8FA3B8', cursor: 'pointer' }} />
          </Tooltip>
        )}
      </Stack>
    )
}

export default SideBarDivider
